import { BASE_URL } from '../../../../../utils/config.base-url'

export const DOCUMENT_OUTGOING_PREFIX_URL = '/document-outgoing'
export const URL_ENDPOINT_DOCUMENT_OUTGOING = `${BASE_URL}/document-outgoing`
export const URL_ENDPOINT_DOCUMENT_OUTGOING_APPROVAL_LOG = `${BASE_URL}/document-outgoing-approval-log/list/by-document-outgoing`
